var map = {
	"./course-01.jpg": 1951,
	"./course-01.svg": 7433,
	"./course-02.jpg": 87600,
	"./course-02.svg": 22970,
	"./course-03.jpg": 39821,
	"./course-03.svg": 53931,
	"./course-04.jpg": 20742,
	"./course-04.svg": 49252,
	"./course-05.jpg": 80227,
	"./course-06.jpg": 34164,
	"./course-07.jpg": 48497,
	"./course-08.jpg": 77386,
	"./course-09.jpg": 33223,
	"./course-10.jpg": 68825,
	"./course-11.jpg": 24476,
	"./course-12.jpg": 49643,
	"./course-13.jpg": 70158,
	"./course-14.jpg": 7221,
	"./course-15.jpg": 46040,
	"./course-16.jpg": 78887,
	"./course-17.jpg": 83082,
	"./course-20.jpg": 12296,
	"./course-21.jpg": 39909,
	"./course-22.jpg": 60301,
	"./course-23.jpg": 34615,
	"./course-24.jpg": 74380,
	"./course-25.jpg": 88521,
	"./course-26.jpg": 97022,
	"./course-27.jpg": 17179,
	"./course-28.jpg": 91872,
	"./course-29.jpg": 43613,
	"./course-30.jpg": 6151,
	"./courses-01.jpg": 42538,
	"./courses-02.jpg": 9877,
	"./courses-03.jpg": 2616,
	"./courses-04.jpg": 25451,
	"./courses-05.jpg": 98990,
	"./courses-06.jpg": 55129,
	"./featured-course-01.jpg": 32356,
	"./featured-course-02.jpg": 16051,
	"./featured-course-03.jpg": 60790,
	"./featured-course-04.jpg": 1309,
	"./featured-course-05.jpg": 92096,
	"./featured-course-06.jpg": 58735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44654;